var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _g, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSidebarLeftWorld(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 276,
    height: 317,
    viewBox: "0 0 276 317",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-63.9308 231.535H203.236C228.243 231.535 248.516 251.807 248.516 276.814V276.814C248.516 299.008 230.524 317 208.33 317H-63.9308V231.535Z",
    fill: "#D8E2E4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4122 162.006L34.2329 169.844L35.7869 174.836L60.9662 166.999L59.4122 162.006Z",
    fill: "#979AA2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7945 153.47L31.6152 161.308L33.1692 166.3L58.3485 158.463L56.7945 153.47Z",
    fill: "#979AA2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1768 144.935L28.9976 152.772L30.5515 157.765L55.7308 149.927L54.1768 144.935Z",
    fill: "#979AA2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.043 159.995L17.8099 166.246L11.5581 146.127L6.55664 147.718L13.2631 169.202C13.9451 171.248 16.1049 172.498 18.2646 171.816L19.5149 171.475L39.748 165.223L38.043 159.995Z",
    fill: "#979AA2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6947 146.582L5.87452 148.741L5.1925 146.468L12.0127 144.195L12.6947 146.582Z",
    fill: "#2E3348"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8659 151.242L52.5925 144.422L54.9796 143.626L57.1393 150.446L54.8659 151.242Z",
    fill: "#2E3348"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4803 159.767L55.2069 152.947L57.594 152.151L59.8673 158.972L57.4803 159.767Z",
    fill: "#2E3348"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0948 168.179L57.9351 161.359L60.2084 160.677L62.4818 167.497L60.0948 168.179Z",
    fill: "#2E3348"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.853259 192.111L-13.7942 196.05L-9.78903 209.208L3.1519 205.269L-0.853259 192.111Z",
    fill: "#979AA2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4917 158.631L27.9263 190.231L59.64 182.388L49.8644 149.196C48.5004 144.422 43.499 141.808 38.7249 143.172L24.5162 147.491C19.8558 148.969 17.1277 153.857 18.4917 158.631Z",
    fill: "#2E3348"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.217 185.911L83.8516 163.859L70.5523 188.526L-1.62766 210.578L-13.9039 170.225L4.73781 164.542L11.217 186.025",
    fill: "#2E3348"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M5.42578 162.681L-15.2362 168.97L-14.8059 170.384L5.85609 164.094L5.42578 162.681Z",
    fill: "#2E3348"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M2.19433 170.987L-7.81042 174.032L-4.76518 184.037L5.23957 180.991L2.19433 170.987Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1105 169.656C39.9399 169.656 43.0443 166.552 43.0443 162.723C43.0443 158.893 39.9399 155.789 36.1105 155.789C32.281 155.789 29.1766 158.893 29.1766 162.723C29.1766 166.552 32.281 169.656 36.1105 169.656Z",
    fill: "#979AA2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1106 168.406C39.2495 168.406 41.794 165.862 41.794 162.723C41.794 159.584 39.2495 157.039 36.1106 157.039C32.9717 157.039 30.4271 159.584 30.4271 162.723C30.4271 165.862 32.9717 168.406 36.1106 168.406Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M8.94353 144.99C8.94353 144.99 7.12482 139.648 2.69172 140.785C-1.74138 141.921 -3.33274 136.92 -4.01476 133.737C-4.81044 130.554 4.28309 130.441 4.28309 130.441C4.28309 130.441 15.7637 132.828 8.94353 144.99Z",
    fill: "#E8E8E7"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M-5.26499 142.149C-2.00054 142.149 0.64581 139.502 0.64581 136.238C0.64581 132.973 -2.00054 130.327 -5.26499 130.327C-8.52943 130.327 -11.1758 132.973 -11.1758 136.238C-11.1758 139.502 -8.52943 142.149 -5.26499 142.149Z",
    fill: "#E8E8E7"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.14997 135.215C2.4867 135.215 4.62414 133.077 4.62414 130.441C4.62414 127.804 2.4867 125.667 -0.14997 125.667C-2.78664 125.667 -4.92407 127.804 -4.92407 130.441C-4.92407 133.077 -2.78664 135.215 -0.14997 135.215Z",
    fill: "#E8E8E7"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M110.653 89.8931L110.706 128.2L115.935 128.192L115.882 89.8858L110.653 89.8931Z",
    fill: "#979AA2"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M101.763 89.9189L101.816 116.29L107.044 116.28L106.991 89.9084L101.763 89.9189Z",
    fill: "#979AA2"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8215 89.8799L92.8744 116.251L98.1032 116.241L98.0503 89.8694L92.8215 89.8799Z",
    fill: "#979AA2"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9698 91.1111L91.8086 91.2247V88.724L98.9698 88.6104V91.1111Z",
    fill: "#2E3348"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M107.949 91.1111L100.788 91.2247V88.724L107.949 88.6104V91.1111Z",
    fill: "#2E3348"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M116.816 91.1111L109.655 91.2247V88.724L116.816 88.6104V91.1111Z",
    fill: "#2E3348"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M147.052 101.114H139.208V108.957H147.052V101.114Z",
    stroke: "#2E3348",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M147.052 101.114H139.208V108.957H147.052V101.114Z",
    stroke: "#2E3348",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M139.208 108.957L146.938 101.114",
    stroke: "#2E3348",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M139.208 101.114L146.938 108.957",
    stroke: "#2E3348",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M147.052 108.957H139.208V116.8H147.052V108.957Z",
    stroke: "#2E3348",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M139.208 116.687L146.938 108.957",
    stroke: "#2E3348",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M139.208 108.957L146.938 116.687",
    stroke: "#2E3348",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M147.052 85.4277H139.208V93.2709H147.052V85.4277Z",
    stroke: "#2E3348",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M147.052 85.4277H139.208V93.2709H147.052V85.4277Z",
    stroke: "#2E3348",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M139.208 93.1572L146.938 85.4277",
    stroke: "#2E3348",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M139.208 85.4277L146.938 93.1572",
    stroke: "#2E3348",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M147.052 93.1572H139.208V101H147.052V93.1572Z",
    stroke: "#2E3348",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M139.208 101L146.938 93.1572",
    stroke: "#2E3348",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M139.208 93.1572L146.938 101",
    stroke: "#2E3348",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M147.052 132.487H139.208V140.33H147.052V132.487Z",
    stroke: "#2E3348",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M147.052 132.487H139.208V140.33H147.052V132.487Z",
    stroke: "#2E3348",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M139.208 140.33L146.938 132.487",
    stroke: "#2E3348",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M139.208 132.487L146.938 140.33",
    stroke: "#2E3348",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M147.052 140.33H139.208V148.173H147.052V140.33Z",
    stroke: "#2E3348",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M139.208 148.173L146.938 140.33",
    stroke: "#2E3348",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M139.208 140.33L146.938 148.173",
    stroke: "#2E3348",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M147.052 116.8H139.208V124.644H147.052V116.8Z",
    stroke: "#2E3348",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M147.052 116.8H139.208V124.644H147.052V116.8Z",
    stroke: "#2E3348",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M139.208 124.644L146.938 116.8",
    stroke: "#2E3348",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M139.208 116.8L146.938 124.644",
    stroke: "#2E3348",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M147.052 124.644H139.208V132.487H147.052V124.644Z",
    stroke: "#2E3348",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M139.208 132.373L146.938 124.644",
    stroke: "#2E3348",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M139.208 124.644L146.938 132.373",
    stroke: "#2E3348",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M127.955 79.9714H196.611",
    stroke: "#2E3348",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M128.183 85.3139L130.683 82.6995L127.955 79.9714L125.454 82.5858L128.069 85.3139L127.955 85.4276H128.296L128.183 85.3139Z",
    stroke: "#2E3348",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M128.069 85.314L125.455 82.5859L122.726 85.314L122.84 85.4277H127.955L128.069 85.314Z",
    stroke: "#2E3348",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M133.298 85.3139L136.026 82.5858L133.411 79.9714L130.683 82.6995L133.298 85.3139ZM133.298 85.3139L133.184 85.4276H133.525L133.298 85.3139Z",
    stroke: "#2E3348",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M133.298 85.314L130.683 82.6996L128.183 85.314L128.296 85.4276H133.184L133.298 85.314Z",
    stroke: "#2E3348",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M138.639 85.3141L138.526 85.4271H138.752L138.639 85.3141Z",
    stroke: "#2E3348",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M138.627 80.028L136.055 82.6L138.707 85.2524L141.279 82.6804L138.627 80.028Z",
    stroke: "#2E3348",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M138.64 85.314V85.2003L136.026 82.5859L133.298 85.314L133.525 85.4277H138.527L138.64 85.314Z",
    stroke: "#2E3348",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M143.939 79.9542L141.286 82.6066L143.858 85.1786L146.511 82.5262L143.939 79.9542Z",
    stroke: "#2E3348",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M143.868 85.3141L143.755 85.4271H143.981L143.868 85.3141Z",
    stroke: "#2E3348",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M143.869 85.314V85.2003L141.255 82.5859L138.64 85.2003L138.754 85.314H138.64L138.754 85.4277H143.755L143.869 85.314Z",
    stroke: "#2E3348",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M149.211 85.3139L151.826 82.6995L149.098 79.9714L146.483 82.5858L149.211 85.3139ZM149.211 85.3139L149.098 85.4276H149.439L149.211 85.3139Z",
    stroke: "#2E3348",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M149.211 85.314L146.483 82.5859L143.869 85.2003V85.314L143.983 85.4277H149.098L149.211 85.314Z",
    stroke: "#2E3348",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M154.44 85.3139L157.168 82.5858L154.554 79.9714L151.826 82.6995L154.44 85.3139ZM154.44 85.3139L154.213 85.4276H154.554L154.44 85.3139Z",
    stroke: "#2E3348",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M154.44 85.314L151.826 82.6996L149.212 85.314L149.439 85.4276H154.213L154.44 85.314Z",
    stroke: "#2E3348",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M159.783 85.3139L162.397 82.6995L159.783 79.9714L157.168 82.5858L159.783 85.3139ZM159.783 85.3139L159.669 85.4276H160.01L159.783 85.3139Z",
    stroke: "#2E3348",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M159.783 85.314L157.168 82.5859L154.44 85.314L154.554 85.4277H159.669L159.783 85.314Z",
    stroke: "#2E3348",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M165.011 85.3139L167.74 82.5858L165.125 79.9714L162.397 82.6995L165.011 85.3139ZM165.011 85.3139L164.898 85.4276H165.125L165.011 85.3139Z",
    stroke: "#2E3348",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M165.011 85.314L162.397 82.6996L159.783 85.314L160.01 85.4276H164.898L165.011 85.314Z",
    stroke: "#2E3348",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M170.468 85.3139L172.968 82.6995L170.354 79.9714L167.74 82.5858L170.354 85.3139L170.24 85.4276H170.581L170.468 85.3139Z",
    stroke: "#2E3348",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M170.354 85.314L167.74 82.5859L165.011 85.314L165.125 85.4277H170.24L170.354 85.314Z",
    stroke: "#2E3348",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M175.696 85.3139L178.311 82.5858L175.696 79.9714L172.968 82.6995L175.583 85.3139L175.469 85.4276H175.81L175.696 85.3139Z",
    stroke: "#2E3348",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M175.583 85.314L172.968 82.6996L170.468 85.314L170.581 85.4276H175.469L175.583 85.314Z",
    stroke: "#2E3348",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M180.925 85.3141V85.4274H181.038L180.925 85.3141Z",
    stroke: "#2E3348",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M180.916 80.0394L178.344 82.6115L180.997 85.2638L183.569 82.6918L180.916 80.0394Z",
    stroke: "#2E3348",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M180.925 85.314V85.2003L178.311 82.5859L175.696 85.314L175.81 85.4277H180.925V85.314Z",
    stroke: "#2E3348",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M186.153 85.3141L186.04 85.4271H186.266L186.153 85.3141Z",
    stroke: "#2E3348",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M186.229 79.9678L183.576 82.6202L186.148 85.1923L188.801 82.5399L186.229 79.9678Z",
    stroke: "#2E3348",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M186.154 85.314V85.2003L183.539 82.5859L180.925 85.2003L181.039 85.314H180.925L181.039 85.4277H186.04L186.154 85.314Z",
    stroke: "#2E3348",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M191.61 85.3139L194.111 82.6995L191.383 79.9714L188.768 82.5858L191.496 85.3139L191.383 85.4276H191.724L191.61 85.3139Z",
    stroke: "#2E3348",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M191.496 85.314L188.768 82.5859L186.154 85.2003V85.314L186.267 85.4277H191.383L191.496 85.314Z",
    stroke: "#2E3348",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M196.725 85.3139L199.453 82.5858L196.839 79.9714L194.111 82.6995L196.725 85.3139ZM196.725 85.3139L196.498 85.4276H196.839L196.725 85.3139Z",
    stroke: "#2E3348",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M196.725 85.314L194.111 82.6996L191.61 85.314L191.724 85.4276H196.498L196.725 85.314Z",
    stroke: "#2E3348",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M202.068 85.314L199.453 82.5859L196.725 85.314L196.839 85.4277H201.954L202.068 85.314Z",
    stroke: "#2E3348",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M107.154 116.346H68.5063V184.547H107.154V116.346Z",
    fill: "#2E3348"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M161.488 108.844H122.84V177.045H161.488V108.844Z",
    fill: "#2E3348"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M172.059 126.462H64.6416V201.711H172.059V126.462Z",
    fill: "#979AA2"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1437 120.665V104.979L68.62 101.455",
    stroke: "#2E3348",
    strokeWidth: 0.983,
    strokeMiterlimit: 10
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M66.233 105.888C67.8244 107.48 70.4388 107.821 72.4848 106.456C74.6446 104.979 75.2129 101.91 73.6215 99.75C73.5079 99.5227 73.2805 99.2953 73.0532 99.068L66.233 105.888Z",
    fill: "#2E3348"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M110.337 108.389H81.8057V118.505H110.337V108.389Z",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5337 113.39H106.131",
    stroke: "#2E3348",
    strokeWidth: 0.983,
    strokeMiterlimit: 10
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M103.289 110.435L106.244 113.39L103.289 116.346",
    stroke: "#2E3348",
    strokeWidth: 0.983,
    strokeMiterlimit: 10
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8098 191.936H73.9623L73.6213 150.787H96.5825L96.8098 191.936Z",
    fill: "#E8E8E7"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M74.417 133.737V141.808",
    stroke: "#2E3348",
    strokeWidth: 0.983,
    strokeMiterlimit: 10
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1451 133.737V141.808",
    stroke: "#2E3348",
    strokeWidth: 0.983,
    strokeMiterlimit: 10
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M75.781 133.737V141.808",
    stroke: "#2E3348",
    strokeWidth: 0.983,
    strokeMiterlimit: 10
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M78.509 133.737V141.808",
    stroke: "#2E3348",
    strokeWidth: 0.983,
    strokeMiterlimit: 10
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9869 133.737V141.808",
    stroke: "#2E3348",
    strokeWidth: 0.983,
    strokeMiterlimit: 10
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M82.715 133.737V141.808",
    stroke: "#2E3348",
    strokeWidth: 0.983,
    strokeMiterlimit: 10
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M81.351 133.737V141.808",
    stroke: "#2E3348",
    strokeWidth: 0.983,
    strokeMiterlimit: 10
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1926 133.737V141.808",
    stroke: "#2E3348",
    strokeWidth: 0.983,
    strokeMiterlimit: 10
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5566 133.737V141.808",
    stroke: "#2E3348",
    strokeWidth: 0.983,
    strokeMiterlimit: 10
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2847 133.737V141.808",
    stroke: "#2E3348",
    strokeWidth: 0.983,
    strokeMiterlimit: 10
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9207 133.737V141.808",
    stroke: "#2E3348",
    strokeWidth: 0.983,
    strokeMiterlimit: 10
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7625 133.737V141.808",
    stroke: "#2E3348",
    strokeWidth: 0.983,
    strokeMiterlimit: 10
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1265 133.737V141.808",
    stroke: "#2E3348",
    strokeWidth: 0.983,
    strokeMiterlimit: 10
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9681 133.737V141.808",
    stroke: "#2E3348",
    strokeWidth: 0.983,
    strokeMiterlimit: 10
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4906 133.737V141.808",
    stroke: "#2E3348",
    strokeWidth: 0.983,
    strokeMiterlimit: 10
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M95.3323 133.737V141.808",
    stroke: "#2E3348",
    strokeWidth: 0.983,
    strokeMiterlimit: 10
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M112.155 148.969L146.597 142.262L147.165 170.907L111.814 164.314",
    stroke: "white",
    strokeWidth: 0.983,
    strokeMiterlimit: 10
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M116.978 162.646C120.317 159.986 120.868 155.123 118.209 151.784C115.549 148.445 110.686 147.894 107.347 150.554C104.008 153.213 103.457 158.076 106.117 161.415C108.776 164.754 113.639 165.305 116.978 162.646Z",
    stroke: "#2E3348",
    strokeWidth: 1.5475,
    strokeMiterlimit: 10
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M115.444 160.385C117.534 158.579 117.764 155.421 115.958 153.331C114.152 151.241 110.994 151.01 108.904 152.816C106.814 154.622 106.583 157.78 108.389 159.871C110.195 161.961 113.353 162.191 115.444 160.385Z",
    stroke: "#2E3348",
    strokeWidth: 1.5475,
    strokeMiterlimit: 10
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M157.647 167.824C163.834 162.795 164.773 153.703 159.745 147.517C154.716 141.33 145.624 140.391 139.438 145.419C133.251 150.447 132.312 159.539 137.34 165.726C142.368 171.913 151.46 172.852 157.647 167.824Z",
    fill: "#E8E8E7"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M157.647 167.824C163.834 162.795 164.773 153.703 159.745 147.517C154.716 141.33 145.624 140.391 139.438 145.419C133.251 150.447 132.312 159.539 137.34 165.726C142.368 171.913 151.46 172.852 157.647 167.824Z",
    stroke: "#2E3348",
    strokeWidth: 1.5475,
    strokeMiterlimit: 10
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M112.269 151.697V161.473",
    stroke: "#2E3348",
    strokeWidth: 1.5475,
    strokeMiterlimit: 10
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M117.157 156.585H107.267",
    stroke: "#2E3348",
    strokeWidth: 1.5475,
    strokeMiterlimit: 10
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M151.586 160.372C153.676 158.566 153.907 155.407 152.101 153.317C150.295 151.227 147.137 150.996 145.046 152.802C142.956 154.608 142.726 157.767 144.532 159.857C146.338 161.947 149.496 162.177 151.586 160.372Z",
    fill: "white"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M148.302 151.697V161.473",
    stroke: "#2E3348",
    strokeWidth: 1.5475,
    strokeMiterlimit: 10
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M151.586 160.372C153.676 158.566 153.907 155.407 152.101 153.317C150.295 151.227 147.137 150.996 145.046 152.802C142.956 154.608 142.726 157.767 144.532 159.857C146.338 161.947 149.496 162.177 151.586 160.372Z",
    stroke: "#2E3348",
    strokeWidth: 1.5475,
    strokeMiterlimit: 10
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M153.304 156.585H143.414",
    stroke: "#2E3348",
    strokeWidth: 1.5475,
    strokeMiterlimit: 10
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M200.021 85.996V119.301",
    stroke: "#F1E8E6",
    strokeWidth: 0.983,
    strokeMiterlimit: 10
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M199.681 123.848C200.873 123.848 201.84 122.881 201.84 121.688C201.84 120.495 200.873 119.528 199.681 119.528C198.488 119.528 197.521 120.495 197.521 121.688C197.521 122.881 198.488 123.848 199.681 123.848Z",
    fill: "#2E3348"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M199.681 122.484V125.439L202.409 128.167L199.908 130.668L197.748 128.508",
    stroke: "#2E3348",
    strokeWidth: 0.983,
    strokeMiterlimit: 10
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M164.216 186.252H116.02V196.823H164.216V186.252Z",
    fill: "#E8E8E7"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M164.216 196.823V186.252H116.02V196.823",
    stroke: "white",
    strokeWidth: 0.983,
    strokeMiterlimit: 10
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M171.945 133.623H109.2V136.238H171.945V133.623Z",
    fill: "white"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M117.384 196.71V187.162H126.932L117.384 196.71Z",
    fill: "#2E3348"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M129.433 196.71V187.162H138.981L129.433 196.71Z",
    fill: "#2E3348"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M141.482 196.71V187.162H151.03L141.482 196.71Z",
    fill: "#2E3348"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M153.531 196.71V187.162H163.079L153.531 196.71Z",
    fill: "#2E3348"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2143 189.662L77.9409 189.776V152.947L80.2143 152.834V189.662Z",
    fill: "white"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3524 189.662L84.079 189.776V152.947L86.3524 152.834V189.662Z",
    fill: "white"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4905 189.662L90.2172 189.776V152.947L92.4905 152.834V189.662Z",
    fill: "white"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M81.351 183.524H76.2358V185.229H81.351V183.524Z",
    fill: "#2E3348"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8301 175.795H82.715V177.5H87.8301V175.795Z",
    fill: "#2E3348"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8546 184.434H88.7395V186.139H93.8546V184.434Z",
    fill: "#2E3348"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M-17.3139 246.156L-18.2233 221.717C-18.2233 221.717 65.2099 196.482 65.3236 196.71C65.7782 197.164 136.594 196.71 160.124 196.71C251.741 196.71 168.08 246.497 167.285 245.133L-17.3139 246.156Z",
    fill: "#2E3348"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M220.937 211.487C216.276 211.487 212.298 208.872 210.365 205.007C208.433 208.872 204.341 211.487 199.794 211.487C195.134 211.487 191.155 208.872 189.223 205.007C187.291 208.872 183.198 211.487 178.652 211.487C173.991 211.487 170.013 208.872 168.08 205.007C166.148 208.872 162.056 211.487 157.509 211.487C152.849 211.487 148.87 208.872 146.938 205.007C145.006 208.872 140.914 211.487 136.367 211.487C131.706 211.487 127.728 208.872 125.796 205.007C123.863 208.872 119.771 211.487 115.224 211.487C110.678 211.487 106.585 208.872 104.653 205.007C102.721 208.872 98.6286 211.487 94.0818 211.487C89.4214 211.487 85.4429 208.872 83.5106 205.007C81.5782 208.872 77.4861 211.487 72.9393 211.487C68.2789 211.487 64.3005 208.872 62.3681 205.007C60.4357 208.872 56.3436 211.487 51.7969 211.487C47.2501 211.487 43.158 208.872 41.2256 205.007C39.2933 208.872 35.2012 211.487 30.6544 211.487C26.1076 211.487 22.0156 208.872 20.0832 205.007C18.1508 208.872 14.0587 211.487 9.51194 211.487C4.96518 211.487 0.873086 208.872 -1.05929 205.007C-2.99167 208.872 -7.08376 211.487 -11.6305 211.487C-16.1773 211.487 -20.2694 208.872 -22.2018 205.007C-24.1341 208.872 -28.2262 211.487 -32.773 211.487C-37.3198 211.487 -41.4118 208.872 -43.3442 205.007C-44.1399 206.599 -45.2766 207.849 -46.6406 208.986V260.705L229.689 257.523V208.531C226.847 210.35 224.006 211.487 220.937 211.487Z",
    fill: "#D8E2E4"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M216.617 222.967V221.831C214.458 223.763 211.73 224.9 208.66 224.9C204 224.9 200.022 222.285 198.089 218.421C196.157 222.285 192.065 224.9 187.518 224.9C182.858 224.9 178.879 222.285 176.947 218.421C175.014 222.285 170.922 224.9 166.376 224.9C161.715 224.9 157.737 222.285 155.804 218.421C153.872 222.285 149.78 224.9 145.233 224.9C140.573 224.9 136.594 222.285 134.662 218.421C132.729 222.285 128.637 224.9 124.091 224.9C119.43 224.9 115.452 222.285 113.519 218.421C111.587 222.285 107.495 224.9 102.948 224.9C98.2877 224.9 94.3093 222.285 92.3769 218.421C90.4445 222.285 86.3524 224.9 81.8057 224.9C77.1452 224.9 73.1668 222.285 71.2344 218.421C69.3021 222.285 65.21 224.9 60.6632 224.9C56.1164 224.9 52.0243 222.285 50.092 218.421C48.1596 222.285 44.0675 224.9 39.5207 224.9C34.8603 224.9 30.8819 222.285 28.9495 218.421C27.0171 222.285 22.925 224.9 18.3783 224.9C13.8315 224.9 9.73941 222.285 7.80703 218.421C5.87466 222.285 1.78257 224.9 -2.7642 224.9C-7.31096 224.9 -11.4031 222.285 -13.3354 218.421C-15.2678 222.285 -19.3599 224.9 -23.9067 224.9C-28.4534 224.9 -32.5455 222.285 -34.4779 218.421C-36.4103 222.285 -40.5024 224.9 -45.0491 224.9C-49.5959 224.9 -53.688 222.285 -55.6204 218.421",
    stroke: "white",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M207.751 237.29V236.153C205.591 238.085 202.863 239.222 199.794 239.222C195.134 239.222 191.155 236.608 189.223 232.743C187.291 236.608 183.199 239.222 178.652 239.222C173.991 239.222 170.013 236.608 168.081 232.743C166.148 236.608 162.056 239.222 157.509 239.222C152.849 239.222 148.87 236.608 146.938 232.743C145.006 236.608 140.914 239.222 136.367 239.222C131.706 239.222 127.728 236.608 125.796 232.743C123.863 236.608 119.771 239.222 115.224 239.222C110.564 239.222 106.586 236.608 104.653 232.743C102.721 236.608 98.6287 239.222 94.0819 239.222C89.5352 239.222 85.4431 236.608 83.5107 232.743C81.5783 236.608 77.4862 239.222 72.9395 239.222C68.279 239.222 64.3006 236.608 62.3682 232.743C60.4358 236.608 56.3438 239.222 51.797 239.222C47.1366 239.222 43.1581 236.608 41.2258 232.743C39.2934 236.608 35.2013 239.222 30.6545 239.222C26.1078 239.222 22.0157 236.608 20.0833 232.743C18.1509 236.608 14.0588 239.222 9.51205 239.222C4.96529 239.222 0.873199 236.608 -1.05918 232.743C-2.99155 236.608 -7.08364 239.222 -11.6304 239.222C-16.1772 239.222 -20.2693 236.608 -22.2016 232.743C-24.134 236.608 -28.2261 239.222 -32.7729 239.222C-37.3196 239.222 -41.4117 236.608 -43.3441 232.743C-45.2765 236.608 -49.3686 239.222 -53.9153 239.222C-58.4621 239.222 -62.5542 236.608 -64.4866 232.743",
    stroke: "white",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M216.617 251.612V250.475C214.458 252.408 211.73 253.544 208.66 253.544C204 253.544 200.022 250.93 198.089 247.065C196.157 250.93 192.065 253.544 187.518 253.544C182.858 253.544 178.879 250.93 176.947 247.065C175.014 250.93 170.922 253.544 166.376 253.544C161.715 253.544 157.737 250.93 155.804 247.065C153.872 250.93 149.78 253.544 145.233 253.544C140.573 253.544 136.594 250.93 134.662 247.065C132.729 250.93 128.637 253.544 124.091 253.544C119.43 253.544 115.452 250.93 113.519 247.065C111.587 250.93 107.495 253.544 102.948 253.544C98.2877 253.544 94.3093 250.93 92.3769 247.065C90.4445 250.93 86.3524 253.544 81.8057 253.544C77.1452 253.544 73.1668 250.93 71.2344 247.065C69.3021 250.93 65.21 253.544 60.6632 253.544C56.1164 253.544 52.0243 250.93 50.092 247.065C48.1596 250.93 44.0675 253.544 39.5207 253.544C34.8603 253.544 30.8819 250.93 28.9495 247.065C27.0171 250.93 22.925 253.544 18.3783 253.544C13.8315 253.544 9.73941 250.93 7.80703 247.065C5.87466 250.93 1.78257 253.544 -2.7642 253.544C-7.31096 253.544 -11.4031 250.93 -13.3354 247.065C-15.2678 250.93 -19.3599 253.544 -23.9067 253.544C-28.4534 253.544 -32.5455 250.93 -34.4779 247.065C-36.4103 250.93 -40.5024 253.544 -45.0491 253.544C-49.5959 253.544 -53.688 250.93 -55.6204 247.065",
    stroke: "white",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M207.751 265.821V264.684C205.591 266.616 202.863 267.753 199.794 267.753C195.134 267.753 191.155 265.139 189.223 261.274C187.291 265.139 183.199 267.753 178.652 267.753C173.991 267.753 170.013 265.139 168.081 261.274C166.148 265.139 162.056 267.753 157.509 267.753C152.849 267.753 148.87 265.139 146.938 261.274C145.006 265.139 140.914 267.753 136.367 267.753C131.706 267.753 127.728 265.139 125.796 261.274C123.863 265.139 119.771 267.753 115.224 267.753C110.564 267.753 106.586 265.139 104.653 261.274C102.721 265.139 98.6287 267.753 94.0819 267.753C89.5352 267.753 85.4431 265.139 83.5107 261.274C81.5783 265.139 77.4862 267.753 72.9395 267.753C68.279 267.753 64.3006 265.139 62.3682 261.274C60.4358 265.139 56.3438 267.753 51.797 267.753C47.1366 267.753 43.1581 265.139 41.2258 261.274C39.2934 265.139 35.2013 267.753 30.6545 267.753C26.1078 267.753 22.0157 265.139 20.0833 261.274C18.1509 265.139 14.0588 267.753 9.51205 267.753C4.96529 267.753 0.873199 265.139 -1.05918 261.274C-2.99155 265.139 -7.08364 267.753 -11.6304 267.753C-16.1772 267.753 -20.2693 265.139 -22.2016 261.274C-24.134 265.139 -28.2261 267.753 -32.7729 267.753C-37.3196 267.753 -41.4117 265.139 -43.3441 261.274C-45.2765 265.139 -49.3686 267.753 -53.9153 267.753C-58.4621 267.753 -62.5542 265.139 -64.4866 261.274",
    stroke: "white",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M252.082 294.465V293.329C249.922 295.261 247.194 296.398 244.125 296.398C239.465 296.398 235.486 293.783 233.554 289.918C231.621 293.783 227.529 296.398 222.983 296.398C218.322 296.398 214.344 293.783 212.411 289.918C210.479 293.783 206.387 296.398 201.84 296.398C197.18 296.398 193.201 293.783 191.269 289.918C189.337 293.783 185.244 296.398 180.698 296.398C176.037 296.398 172.059 293.783 170.126 289.918C168.194 293.783 164.102 296.398 159.555 296.398C154.895 296.398 150.916 293.783 148.984 289.918C147.052 293.783 142.959 296.398 138.413 296.398C133.866 296.398 129.774 293.783 127.841 289.918C125.909 293.783 121.817 296.398 117.27 296.398C112.61 296.398 108.631 293.783 106.699 289.918C104.767 293.783 100.675 296.398 96.1278 296.398C91.4674 296.398 87.4889 293.783 85.5566 289.918C83.6242 293.783 79.5321 296.398 74.9853 296.398C70.4386 296.398 66.3465 293.783 64.4141 289.918C62.4817 293.783 58.3896 296.398 53.8429 296.398C49.2961 296.398 45.204 293.783 43.2716 289.918C41.3393 293.783 37.2472 296.398 32.7004 296.398C28.1536 296.398 24.0615 293.783 22.1292 289.918C20.1968 293.783 16.1047 296.398 11.5579 296.398C7.01117 296.398 2.91908 293.783 0.986704 289.918C-0.945672 293.783 -5.03776 296.398 -9.58453 296.398C-14.1313 296.398 -18.2234 293.783 -20.1558 289.918",
    stroke: "#FCFCFC",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M281.295 304.241C279.363 308.105 275.27 310.72 270.724 310.72C266.177 310.72 262.085 308.105 260.152 304.241C258.22 308.105 254.128 310.72 249.581 310.72C245.034 310.72 240.942 308.105 239.01 304.241C237.078 308.105 232.986 310.72 228.439 310.72C223.778 310.72 219.8 308.105 217.868 304.241C215.935 308.105 211.843 310.72 207.296 310.72C202.75 310.72 198.657 308.105 196.725 304.241C194.793 308.105 190.701 310.72 186.154 310.72C181.493 310.72 177.515 308.105 175.583 304.241C173.65 308.105 169.558 310.72 165.011 310.72C160.351 310.72 156.373 308.105 154.44 304.241C152.508 308.105 148.416 310.72 143.869 310.72C139.208 310.72 135.23 308.105 133.298 304.241C131.365 308.105 127.273 310.72 122.726 310.72C118.066 310.72 114.088 308.105 112.155 304.241C110.223 308.105 106.131 310.72 101.584 310.72C96.9235 310.72 92.9451 308.105 91.0127 304.241C89.0803 308.105 84.9883 310.72 80.4415 310.72C75.8947 310.72 71.8026 308.105 69.8702 304.241C67.9379 308.105 63.8458 310.72 59.299 310.72C54.7523 310.72 50.6602 308.105 48.7278 304.241",
    stroke: "#FCFCFC",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0894 24.149C66.1131 24.149 70.9963 19.2658 70.9963 13.2422C70.9963 7.21848 66.1131 2.33533 60.0894 2.33533C54.0658 2.33533 49.1826 7.21848 49.1826 13.2422C49.1826 19.2658 54.0658 24.149 60.0894 24.149Z",
    fill: "white"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M78.547 24.3587C81.7905 24.3587 84.4199 21.7293 84.4199 18.4858C84.4199 15.2423 81.7905 12.6129 78.547 12.6129C75.3035 12.6129 72.6741 15.2423 72.6741 18.4858C72.6741 21.7293 75.3035 24.3587 78.547 24.3587Z",
    fill: "white"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0892 24.3588H79.1762L68.8986 11.3545L60.0892 24.3588Z",
    fill: "white"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M72.884 16.8079C76.1275 16.8079 78.7569 14.1786 78.7569 10.935C78.7569 7.69152 76.1275 5.06213 72.884 5.06213C69.6405 5.06213 67.0111 7.69152 67.0111 10.935C67.0111 14.1786 69.6405 16.8079 72.884 16.8079Z",
    fill: "white"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M95.787 72.924C95.787 67.6953 91.5813 63.4895 86.3525 63.4895H86.2388C86.4662 62.6938 86.5798 61.7845 86.5798 60.9888C86.5798 55.76 82.3741 51.5542 77.1453 51.5542C74.6446 51.5542 72.4849 52.4636 70.7798 54.055C67.4834 49.7355 62.3683 46.8938 56.5712 46.8938C50.8877 46.8938 45.7726 49.6219 42.4762 53.8276C39.1798 49.6219 34.1783 46.8938 28.3812 46.8938C18.6057 46.8938 10.5352 54.8506 10.5352 64.7399C10.5352 74.5154 18.492 82.5859 28.3812 82.5859H56.5712H59.5266H87.7165L87.6029 82.4722C92.1496 81.6766 95.787 77.6981 95.787 72.924Z",
    stroke: "#E8E8E7",
    strokeWidth: 0.8019,
    strokeMiterlimit: 10
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M238.101 69.6276C237.873 65.7628 234.691 62.8074 230.826 63.0348H230.712C230.826 62.4664 230.94 61.7844 230.826 61.1024C230.599 57.2376 227.416 54.2822 223.551 54.5096C221.732 54.6233 220.141 55.4189 219.004 56.5556C216.504 53.4866 212.639 51.6679 208.319 51.7815C201.158 52.1225 195.589 58.2607 195.93 65.4218C196.271 72.583 202.409 78.1528 209.57 77.8118L232.417 76.6751V76.5614C235.714 76.2204 238.214 73.1513 238.101 69.6276Z",
    fill: "#FCFCFC"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M223.327 114.637H218.78V249.904H223.327V114.637Z",
    fill: "#2E3348",
    stroke: "white",
    strokeWidth: 0.672464,
    strokeMiterlimit: 10
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M241.497 215.518H212.991V194.895H241.497C242.153 194.895 242.679 195.157 243.073 195.551L251.086 203.564C252.005 204.484 252.005 205.797 251.086 206.717L243.073 214.73C242.679 215.255 242.022 215.518 241.497 215.518Z",
    fill: "#979AA2",
    stroke: "#E8E8E7",
    strokeWidth: 0.672464,
    strokeMiterlimit: 10
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M237.424 215.518H208.919V194.895H237.424C238.081 194.895 238.607 195.157 239.001 195.551L247.014 203.564C247.933 204.484 247.933 205.797 247.014 206.717L239.001 214.73C238.475 215.255 237.95 215.518 237.424 215.518Z",
    fill: "#43647B"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M236.242 163.368L207.737 163.5L207.606 142.876L236.111 142.745C236.768 142.745 237.293 143.007 237.687 143.402L245.832 151.415C246.751 152.334 246.751 153.648 245.832 154.567L237.819 162.711C237.424 163.106 236.899 163.368 236.242 163.368Z",
    fill: "#979AA2",
    stroke: "#E8E8E7",
    strokeWidth: 0.672464,
    strokeMiterlimit: 10
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M232.17 163.368L203.665 163.5L203.534 142.876L232.039 142.745C232.696 142.745 233.221 143.007 233.615 143.402L241.759 151.415C242.679 152.334 242.679 153.648 241.759 154.567L233.747 162.711C233.352 163.106 232.827 163.368 232.17 163.368Z",
    fill: "#BFC8B8"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M238.869 122.384L216.144 139.592L212.991 139.329L224.026 106.227C224.551 105.833 227.572 105.438 228.098 105.57L239.395 107.146C240.577 107.278 241.497 108.46 241.365 109.642L239.789 120.939C239.658 121.464 239.263 121.99 238.869 122.384Z",
    fill: "#979AA2",
    stroke: "#E8E8E7",
    strokeWidth: 0.672464,
    strokeMiterlimit: 10
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M235.585 123.041L212.86 140.249L200.381 123.829L223.106 106.621C223.632 106.227 224.157 106.095 224.814 106.227L236.111 107.803C237.293 107.934 238.213 109.116 238.081 110.299L236.505 121.596C236.374 122.121 235.979 122.647 235.585 123.041Z",
    fill: "#FA1439"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M228.623 190.034H200.118V169.411H228.623C229.28 169.411 229.806 169.673 230.2 170.068L238.213 178.081C239.132 179 239.132 180.314 238.213 181.233L230.2 189.246C229.806 189.772 229.149 190.034 228.623 190.034Z",
    fill: "#979AA2",
    stroke: "#E8E8E7",
    strokeWidth: 0.672464,
    strokeMiterlimit: 10
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M224.551 190.034H196.046V169.411H224.551C225.208 169.411 225.733 169.673 226.127 170.068L234.14 178.081C235.06 179 235.06 180.314 234.14 181.233L226.127 189.246C225.602 189.772 225.077 190.034 224.551 190.034Z",
    fill: "#E5B279"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M214.699 149.707H219.165V150.889H216.144V152.071H218.771V153.254H216.144V155.749H214.568L214.699 149.707Z",
    fill: "white"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M220.085 149.707H222.581C222.975 149.707 223.369 149.707 223.632 149.838C223.894 149.97 224.157 149.97 224.42 150.232C224.683 150.364 224.814 150.626 224.945 150.889C225.077 151.152 225.077 151.415 225.077 151.809C225.077 152.071 225.077 152.203 224.945 152.465C224.945 152.597 224.814 152.86 224.683 152.991C224.551 153.122 224.42 153.254 224.289 153.385C224.157 153.516 224.026 153.648 223.763 153.648C223.632 153.779 223.369 153.779 223.106 153.779C222.844 153.779 222.712 153.779 222.449 153.779H221.399V155.881H219.822L220.085 149.707ZM222.581 152.334C222.712 152.334 222.844 152.334 222.975 152.334C223.106 152.334 223.238 152.203 223.238 152.203C223.369 152.203 223.369 152.071 223.369 151.94C223.369 151.809 223.369 151.677 223.369 151.546C223.369 151.415 223.369 151.283 223.369 151.152C223.369 151.021 223.238 151.021 223.238 150.889C223.106 150.889 223.106 150.758 222.975 150.758C222.844 150.758 222.712 150.758 222.581 150.758H221.53V152.334H222.581ZM222.055 153.122H223.763L225.602 155.618H223.894L222.055 153.122Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_144_207694)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.296 130.333C214.04 130.441 213.77 130.511 213.494 130.539C213.235 130.563 212.974 130.548 212.72 130.494C212.456 130.438 212.201 130.343 211.965 130.211C211.705 130.068 211.462 129.895 211.243 129.693C210.993 129.469 210.768 129.22 210.569 128.948V128.948C210.273 128.559 210.038 128.124 209.875 127.661C209.733 127.273 209.672 126.86 209.694 126.447C209.72 126.05 209.839 125.665 210.039 125.322C210.264 124.942 210.563 124.611 210.918 124.351C211.155 124.16 211.415 124.001 211.692 123.877C211.948 123.768 212.219 123.7 212.495 123.675C212.755 123.648 213.017 123.661 213.273 123.715C213.536 123.774 213.79 123.87 214.028 123.999C214.288 124.141 214.531 124.315 214.75 124.517C214.997 124.743 215.223 124.992 215.424 125.261V125.261C215.717 125.653 215.947 126.089 216.106 126.552C216.248 126.94 216.309 127.354 216.286 127.767C216.259 128.164 216.141 128.549 215.941 128.892C215.716 129.271 215.417 129.602 215.063 129.863C214.828 130.052 214.571 130.21 214.296 130.333V130.333ZM214.609 128.621C214.684 128.522 214.739 128.409 214.77 128.289C214.803 128.157 214.815 128.02 214.806 127.884C214.795 127.726 214.763 127.571 214.71 127.423C214.646 127.238 214.564 127.06 214.465 126.892C214.345 126.682 214.211 126.481 214.064 126.289V126.289C213.92 126.095 213.763 125.911 213.594 125.739C213.46 125.599 213.314 125.472 213.157 125.359C213.033 125.267 212.898 125.192 212.756 125.136C212.627 125.088 212.491 125.063 212.354 125.063C212.231 125.062 212.109 125.084 211.993 125.128C211.873 125.174 211.76 125.237 211.656 125.314C211.552 125.395 211.459 125.488 211.38 125.593C211.308 125.695 211.254 125.809 211.223 125.929C211.187 126.061 211.175 126.198 211.187 126.334C211.206 126.486 211.241 126.635 211.291 126.779C211.356 126.964 211.436 127.143 211.532 127.313C211.654 127.522 211.788 127.723 211.933 127.916C212.074 128.113 212.227 128.301 212.391 128.479C212.525 128.619 212.673 128.745 212.832 128.855C212.956 128.945 213.091 129.02 213.233 129.078C213.361 129.126 213.497 129.151 213.634 129.151C213.757 129.153 213.88 129.132 213.995 129.09C214.118 129.042 214.232 128.976 214.336 128.896C214.44 128.818 214.532 128.725 214.609 128.621V128.621Z",
    fill: "#F8F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.328 121.922L215.989 120.66L220.487 122.975L219.448 121.659L217.711 119.332L218.938 118.397L222.926 123.699L221.253 124.974L216.764 122.647L217.803 123.962L219.54 126.277L218.312 127.212L214.328 121.922Z",
    fill: "#F8F9FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.038 117.568L223.877 114.637L224.68 115.714L222.152 117.64L222.926 118.685L225.221 116.936L226.024 118.013L223.729 119.741L224.531 120.793L227.079 118.851L227.881 119.923L224.022 122.87L220.038 117.568Z",
    fill: "#F8F9FA"
  }))), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M207.343 176.767H209.313L211.547 182.809H209.97L209.445 181.364H207.212L206.686 182.809H205.11L207.343 176.767ZM209.051 180.182L208.263 178.08L207.474 180.182H209.051Z",
    fill: "white"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M212.203 176.767H214.174L216.144 180.97V179.394V176.767H217.589V182.809H215.619L213.648 178.606V180.182V182.809H212.203V176.767Z",
    fill: "white"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M220.742 201.594H222.318V204.221H222.187L224.42 201.594H226.259L223.632 204.747V204.221L226.522 207.637H224.551L222.318 205.009H222.449V207.637H220.873L220.742 201.594Z",
    fill: "white"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M226.784 201.594H231.251V202.776H228.361V203.958H230.988V205.141H228.361V206.323H231.251V207.505H226.784V201.594Z",
    fill: "white"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M130.115 54.6233C131.559 54.6233 132.73 53.4528 132.73 52.0089C132.73 50.565 131.559 49.3945 130.115 49.3945C128.671 49.3945 127.501 50.565 127.501 52.0089C127.501 53.4528 128.671 54.6233 130.115 54.6233Z",
    fill: "#2E3348"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M127.501 31.3211L145.233 28.1383C147.166 27.7973 148.53 26.0923 148.53 24.1599",
    stroke: "#2E3348",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M132.843 30.4117L132.957 25.2966",
    stroke: "#2E3348",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M141.709 28.934L138.868 24.5009",
    stroke: "#2E3348",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M133.298 27.6838C139.764 27.6838 145.006 22.442 145.006 15.9759C145.006 9.50976 139.764 4.26794 133.298 4.26794C126.832 4.26794 121.59 9.50976 121.59 15.9759C121.59 22.442 126.832 27.6838 133.298 27.6838Z",
    fill: "#E8E8E7"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M132.616 25.1829L106.358 28.8203C105.449 28.934 105.221 27.6836 106.017 27.4563L130.797 19.3857L132.616 25.1829Z",
    fill: "#E8E8E7"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M111.814 26.206L108.632 21.2046L105.449 21.6593L106.586 27.9111L111.814 26.206Z",
    fill: "#E8E8E7"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M135.458 4.49512C132.388 5.97282 130.342 9.15555 130.342 12.793C130.342 17.9081 134.435 22.0002 139.55 22.0002C141.141 22.0002 142.619 21.5455 143.983 20.8635C144.665 19.3858 145.006 17.7944 145.006 16.0894C145.006 10.2922 140.914 5.51814 135.458 4.49512Z",
    fill: "#2E3348"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M107.04 31.4347C109.049 31.4347 110.678 29.8062 110.678 27.7973C110.678 25.7884 109.049 24.1599 107.04 24.1599C105.031 24.1599 103.403 25.7884 103.403 27.7973C103.403 29.8062 105.031 31.4347 107.04 31.4347Z",
    stroke: "#2E3348",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M108.41 29.7758C109.497 29.0291 109.773 27.5429 109.026 26.4564C108.279 25.3698 106.793 25.0943 105.706 25.841C104.62 26.5877 104.344 28.0738 105.091 29.1604C105.838 30.247 107.324 30.5225 108.41 29.7758Z",
    stroke: "#2E3348",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M107.267 25.2967C107.154 24.9557 106.813 24.7284 106.472 24.7284C106.131 24.8421 105.903 25.1831 105.903 25.5241C105.903 25.6377 105.903 25.6377 106.017 25.7514L107.04 27.6838L107.267 25.5241C107.267 25.5241 107.267 25.4104 107.267 25.2967Z",
    fill: "#2E3348"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M107.04 27.7974L106.813 30.0707C106.813 30.1844 106.813 30.1844 106.813 30.2981C106.926 30.6391 107.267 30.8664 107.608 30.8664C107.949 30.7528 108.177 30.4118 108.177 30.0707C108.177 29.9571 108.177 29.8434 108.063 29.8434L107.04 27.7974Z",
    fill: "#2E3348"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M109.541 28.0247C109.882 27.911 110.109 27.57 110.109 27.229C109.996 26.888 109.655 26.6606 109.314 26.6606C109.2 26.6606 109.2 26.6606 109.086 26.7743L107.154 27.7973L109.314 28.0247C109.314 28.0247 109.427 28.0247 109.541 28.0247Z",
    fill: "#2E3348"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M107.04 27.7974L104.767 27.5701C104.653 27.5701 104.653 27.5701 104.539 27.5701C104.198 27.6837 103.971 28.0247 103.971 28.3658C104.085 28.7068 104.426 28.9341 104.767 28.9341C104.88 28.9341 104.994 28.9341 104.994 28.8204L107.04 27.7974Z",
    fill: "#2E3348"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M140.686 2.44909C142.505 2.10808 143.755 1.31239 143.642 0.744048C143.528 0.175702 141.937 -0.0516359 140.232 0.289372C139.891 0.403041 139.436 0.51671 139.095 0.630379L129.547 3.47211L139.209 2.67642C139.777 2.67642 140.232 2.56275 140.686 2.44909Z",
    fill: "#2E3348"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M129.547 3.47205L119.544 4.3814C119.203 4.3814 118.862 4.49507 118.407 4.49507C116.588 4.83608 115.338 5.63176 115.452 6.20011C115.565 6.76845 117.157 6.99579 118.862 6.65478C119.316 6.54111 119.657 6.42744 120.112 6.31378L129.547 3.47205Z",
    fill: "#2E3348"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M128.41 2.33529L128.751 5.51803L131.706 4.72234L130.115 1.88062L128.41 2.33529Z",
    fill: "#2E3348"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M125.114 32.7987L142.846 29.616C144.778 29.275 146.142 27.5699 146.142 25.6376",
    stroke: "#2E3348",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M252.65 51.9358C252.65 49.1289 250.421 46.9095 247.601 46.9095C246.355 46.9095 245.174 47.3665 244.322 48.0845C244.06 45.5388 241.895 43.5152 239.272 43.5152C238.617 43.5152 238.026 43.6458 237.436 43.8416C237.436 43.5805 237.502 43.3194 237.502 43.0583C237.502 38.2279 233.567 34.3114 228.714 34.3114C226.747 34.3114 224.911 34.9642 223.402 36.0738C221.501 29.0894 215.074 23.9326 207.401 23.9326C198.22 23.9326 190.81 31.3087 190.81 40.4473C190.81 40.5126 190.81 40.5126 190.81 40.5778C189.498 39.8598 187.99 39.4029 186.416 39.4029C181.563 39.4029 177.629 43.3194 177.629 48.1498C177.629 52.9802 181.563 56.8967 186.416 56.8967C186.416 56.8967 186.416 56.8967 186.482 56.8967H247.798C250.486 56.8314 252.65 54.6773 252.65 51.9358Z",
    stroke: "white",
    strokeWidth: 0.7676,
    strokeMiterlimit: 10
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M130.456 31.8894L130.57 26.7743",
    stroke: "#2E3348",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M139.322 30.4117L136.48 25.9786",
    stroke: "#2E3348",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M135.117 27.6836C136.481 32.1167 137.049 37.1181 136.026 41.6649C135.571 43.4836 133.184 48.8261 129.66 51.2131",
    stroke: "#2E3348",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M144.264 56.8917L114.921 46.7939L112.886 52.7057L142.23 62.8034L144.264 56.8917Z",
    fill: "#979AA2"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M140.459 63.262L143.073 55.3052L145.801 56.2145L143.187 64.1714L140.459 63.262Z",
    fill: "#2E3348"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M222.076 254.223C224.964 254.223 227.305 252.747 227.305 250.927C227.305 249.106 224.964 247.63 222.076 247.63C219.189 247.63 216.848 249.106 216.848 250.927C216.848 252.747 219.189 254.223 222.076 254.223Z",
    fill: "#EDC79E"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M222.076 249.79C205.594 249.79 192.295 263.203 192.295 279.685C192.295 283.777 193.091 287.756 194.682 291.393C197.069 290.257 199.001 288.324 200.252 286.051C202.184 289.916 206.276 292.53 210.823 292.53C215.37 292.53 219.462 289.916 221.394 286.051C223.327 289.916 227.419 292.53 231.965 292.53C236.626 292.53 240.604 289.916 242.537 286.051C243.901 288.779 246.288 290.939 249.243 291.848C250.948 288.097 251.858 284.005 251.858 279.685C251.858 263.203 238.558 249.79 222.076 249.79Z",
    fill: "#E5B279"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M251.858 283.777H192.295C190.021 283.777 188.089 281.959 188.089 279.572C188.089 277.298 189.908 275.366 192.295 275.366H251.971C254.245 275.366 256.177 277.185 256.177 279.572C256.063 281.959 254.245 283.777 251.858 283.777Z",
    fill: "#EDC79E"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M271.406 280.143V279.006C269.246 280.939 266.518 282.075 263.449 282.075C258.789 282.075 254.81 279.461 252.878 275.596C250.945 279.461 246.853 282.075 242.307 282.075C237.646 282.075 233.668 279.461 231.735 275.596C229.803 279.461 225.711 282.075 221.164 282.075C216.504 282.075 212.525 279.461 210.593 275.596C208.66 279.461 204.568 282.075 200.022 282.075C195.361 282.075 191.383 279.461 189.45 275.596C187.518 279.461 183.426 282.075 178.879 282.075C174.219 282.075 170.24 279.461 168.308 275.596C166.376 279.461 162.283 282.075 157.737 282.075C153.076 282.075 149.098 279.461 147.165 275.596C145.233 279.461 141.141 282.075 136.594 282.075C131.934 282.075 127.955 279.461 126.023 275.596C124.091 279.461 119.999 282.075 115.452 282.075C110.905 282.075 106.813 279.461 104.881 275.596C102.948 279.461 98.8561 282.075 94.3093 282.075C89.6489 282.075 85.6704 279.461 83.7381 275.596C81.8057 279.461 77.7136 282.075 73.1668 282.075C68.6201 282.075 64.528 279.461 62.5956 275.596C60.6632 279.461 56.5711 282.075 52.0244 282.075C47.4776 282.075 43.3855 279.461 41.4531 275.596C39.5208 279.461 35.4287 282.075 30.8819 282.075C26.3351 282.075 22.2431 279.461 20.3107 275.596C18.3783 279.461 14.2862 282.075 9.73945 282.075C5.19268 282.075 1.10059 279.461 -0.831787 275.596",
    stroke: "#FCFCFC",
    strokeWidth: 0.4915,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_144_207694"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.1871,
    height: 15.9137,
    fill: "white",
    transform: "translate(209.686 114.637)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarLeftWorld);
export default __webpack_public_path__ + "static/media/sidebar_left_world.d1be54ef850f30659fc99f6353c1e164.svg";
export { ForwardRef as ReactComponent };